module.exports = __webpack_public_path__ + "img/Element3_Fehler_Ziffernrechnen.cbb960aa.png";